import React from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { MediaProvider } from '@atlaskit/editor-common/provider-factory';
import type { DocNode } from '@atlaskit/adf-schema';

import type { GenerateImageProps } from '@atlassian/ai-image-generation';
import type { AiStreamingOrchestratorPlugin } from '@atlassian/editor-plugin-ai-streaming-orchestrator';
import type { AIPlugin } from '@atlassian/editor-plugin-ai';

import { fg } from '@confluence/feature-gating';

import { useRovoBridgeCommandListener } from './hooks/useRovoBridgeCommandListener';

export interface UseRovoBridgeCommandListenerParams {
	editorAPI: PublicPluginAPI<[AIPlugin, AiStreamingOrchestratorPlugin]> | undefined;
	onTitleChange?: (title: string) => void;
	contentId: string;
	contentContext: 'staging-area' | 'global';
	setEditorDisabled: (disabled: boolean) => void;
	forceDraftSync?: () => Promise<DocNode>;
	generateAIHeaderImage?: (props: GenerateImageProps) => Promise<void>;
	fakeGenerateAIHeaderImage?: () => Promise<void>;
	mediaProvider?: Promise<MediaProvider>; // Image processor for handling media collection IDs
}

const RovoBridgeCommandListenerImpl = (props: UseRovoBridgeCommandListenerParams) => {
	useRovoBridgeCommandListener(props);
	return null;
};

export const RovoBridgeCommandListener = (props: UseRovoBridgeCommandListenerParams) => {
	if (!fg('aifc_create_enabled')) {
		return null;
	}

	return <RovoBridgeCommandListenerImpl {...props} />;
};
